module.exports = __webpack_public_path__ + "media/images/signal-strength-80-6822516609695fcee77d8e79256c3393.svg";